'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavDrawerFooter", {
    enumerable: true,
    get: function() {
        return NavDrawerFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdrawer = require("@fluentui/react-drawer");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavDrawerFooter = require("./useNavDrawerFooter");
const _useNavDrawerFooterStylesstyles = require("./useNavDrawerFooterStyles.styles");
const NavDrawerFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavDrawerFooter.useNavDrawerFooter_unstable)(props, ref);
    (0, _useNavDrawerFooterStylesstyles.useNavDrawerFooterStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavDrawerFooterStyles_unstable')(state);
    return (0, _reactdrawer.renderDrawerFooter_unstable)(state);
});
NavDrawerFooter.displayName = 'NavDrawerFooter';
